/*======  Define import  ======*/
/*------  React ------*/
import React, { useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";
/*------ Compornent Js/Jsx ------*/
import { TOKEN_STORAGE, AUTH_TOKEN, PUBLIC_KEY } from "./CodeDefinition";
import axios from 'axios';
import { Buffer } from 'buffer';
const crypto = require('crypto');



/*======  Define global variables/functions   ======*/
const consoleLogOutput = false;	//コンソールログ個別出力制御用

/*------ Contextの作成 ------*/
const dataContext = createContext();	//データ取得用

/*------ Contextをexportし他コンポーネントで利用可とする ------*/
export const useData = () => {
	return useContext(dataContext)
};

/*------ データ取得用Provider ------*/
export const ProvideData = ({ children }) => {
	const apiData = useProvideData();
	return (
		<dataContext.Provider value={apiData}>{children}</dataContext.Provider>
	);
};

const encryptData = async (data) => {
    // 公開鍵をセッションストレージから取得し、適切なフォーマットに変換
    let publicKey = sessionStorage.getItem(PUBLIC_KEY);
    publicKey = JSON.parse(publicKey).replace(/\\n/g, '\n');
    const blockSize = 128; // ブロックサイズを設定

    try {
        // データを JSON 文字列に変換
        const plaintext = JSON.stringify(data);

        // データをブロックに分割
        const blocks = [];
        for (let i = 0; i < plaintext.length; i += blockSize) {
            blocks.push(plaintext.slice(i, i + blockSize));
        }

        // ブロックごとに非同期に暗号化
        const encryptedBlockPromises = blocks.map(async (block, i) => {
            const encryptedBlock = crypto.publicEncrypt(
                {
                    key: publicKey,
                    padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
                },
                Buffer.from(block)
            );
            return encryptedBlock.toString('base64');
        });

        // すべての暗号化を非同期に実行
        const encryptedBlocks = await Promise.all(encryptedBlockPromises);
        return encryptedBlocks;
    } catch (error) {
        console.error('データの暗号化中にエラーが発生しました。', error);
        throw error;
    }
};

/*------ データ取得用Providerの実体 ------*/
export const useProvideData = () => {
    const navigate = useNavigate(); //画面遷移用

	/*-----------------------------*/
	/*------ CALL API (POST) ------*/
	/*-----------------------------*/
	// apiName: API Endpoint Name
	// apiPath: API Path
	// apiBody: API POST Data
	// callback:
	//　isSuccessed :true/false
	//　location: function name
	//　responseData: response data
	const getDataPost = async (apiPath, apiBody, callback) => {
		const tokenValue = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE)) || {};
		const authToken = sessionStorage.getItem(AUTH_TOKEN) || 'firstAuth';
	
		const axiosInstance = axios.create({
		baseURL: process.env.REACT_APP_API_ENDPOINT1_URL,
		headers: {
			'Content-Type': 'application/json',
			'X-Api-Key': process.env.REACT_APP_API_ENDPOINT1_KEY,
			'Pragma':'no-cache',
			'Cache-Control':'no-store',
			'X-TIII-Token': authToken,
			'Authorization': `Bearer ${tokenValue.id || ''}`,
			"X-Frame-Options": "DENY",
			"X-Frame-Options": "SAMEORIGIN"
		},
		});

        try {
            consoleLogOutput && console.log("useProvideData getDataPost apiPath:" + apiPath);
            consoleLogOutput && console.log("useProvideData getDataPost apiBody:" + apiBody);

            const encryptdata = apiPath === '/common/getpublickey' ? apiBody : await encryptData(apiBody);
			const responseData = await axiosInstance.post(apiPath, encryptdata);

            consoleLogOutput && console.log("useProvideData getDataPost API.post OK");
            callback({ isSuccessed: true, message: "", responseData: responseData });

        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    window.alert('セッションが切れました。再認証します。');
                    navigate('/');
                } else {
                    consoleLogOutput && console.log("useProvideData getDataPost API.post NG(abnormal)");
                    consoleLogOutput && console.log(error.response.data.data);
                    callback({ isSuccessed: false, location: "getDataPost", message: error.message, responseData: error.response });
                }
            } else {
                consoleLogOutput && console.log("useProvideData getDataPost API.post NG(abnormal)");
                consoleLogOutput && console.log(error);
                callback({ isSuccessed: false, location: "getDataPost", message: error.message, responseData: null });
            }
        }

        consoleLogOutput && console.log("useProvideData getDataPost OUT");
    };
    return {
        getDataPost,
    };
};


/* How To Use */
// const [dialogMessage, setDialogMessage] = useState({     //ダイアログ表示用
// 	open:false
// });
// getCurrentSession(dialogMessage, setDialogMessage,(result)=>{
// 	outputLog(result, consoleLogOutput);
// });

/* <Dialog
content={dialogMessage}
set={setDialogMessage} />*/
/*------ CognitoからSession情報を取得 ------*/
// export const getCurrentSession = async (sessionMessage,setSessionMessage,callback) => {

// 		/*------ Cognitoのセッションを確認 ------*/
// 		await Auth.currentSession()
// 			.then(user => { //正常
// 				//Session期限内なのでスルー
// 				callback({ isSuccessed: true, location: "getDataPost", message: '', responseData: user });
// 			})
// 			.catch(e => { //異常
// 				setSessionMessage({      
// 					...sessionMessage,
// 					open:true,
// 					message:'BC006', 
// 					level:'session',
// 					pattern: 1//OKボタンのみ
// 				})
// 				callback({ isSuccessed: false, location: "getDataPost", message: 'No current user', responseData: e });
// 			});

// };

